// import the required animation functions from the angular animations module
import {state, sequence, trigger, stagger, animate, style, group, query as q, transition, keyframes, animateChild} from '@angular/animations';




const query = (s,a,o={optional:true})=>q(s,a,o);
const cubicBezier = 'cubic-bezier(.79,.09,.47,.9)' 





// * => work-1, work-2, work-3, etc
const matchesIntroToStory = (fromState: string, toState: string): boolean => (!!toState && toState.toString().toLowerCase().startsWith('story-'));

const matchesGoHome = (fromState: string, toState: string): boolean =>
  (
    toState !== null
    && !!fromState
    && fromState.toString().toLowerCase().startsWith('story-')
    && toState.toString().toLowerCase() == 'home'
    );

const matchesNextSection = (fromState: string, toState: string): boolean =>
  (
    toState !== null
    && !!fromState
    && (parseFloat(fromState.replace('intro-','')) < parseFloat(toState.replace('intro-','')) || parseFloat(fromState.replace('story-','')) < parseFloat(toState.replace('intro-','')))
    );

const matchesPrevSection = (fromState: string, toState: string): boolean =>
  (
    toState !== null
    && !!fromState
    && (parseFloat(fromState.replace('intro-','')) > parseFloat(toState.replace('intro-','')) || parseFloat(fromState.replace('story-','')) > parseFloat(toState.replace('intro-','')))
    );


const animPrevSection = [
        query(':enter, :leave', style({ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }), { optional: true }),
        query(':leave', style({ transform: "translate3d(0,0,0)" })),
        query(':enter', style({ transform: "translate3d(0%,-50%,0)"})),
        sequence([  
            query(':leave', animateChild()), 
            group([
                query(':leave', [
                    animate('1s '+cubicBezier, 
                      style({ transform: "translate3d(0,100%,0)"}))
                ]),
                query(':enter', [
                  animate('1s '+cubicBezier, 
                    style({ transform: "translate3d(0,0%,0)"}))
                ])
            ]),
            query(':enter', animateChild()),
        ])
    ];

const animNextSection = [
        query(':enter, :leave', style({ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }), { optional: true }),
        query(':leave', style({ transform: "translate3d(0,0,0)" })),
        query(':enter', style({ transform: "translate3d(0,50%,0)"})),
        sequence([
            query(':leave', animateChild()), 
            group([
                query(':leave', [
                    animate('1s '+cubicBezier, 
                      style({ transform: "translate3d(0,-100%,0)" }))
                ]),
                query(':enter', [
                  animate('1s '+cubicBezier, 
                    style({ transform: "translate3d(0,0,0)" }))
                ])
            ]),
            query(':enter', animateChild()),
        ])
    ];

 const animBack = [
        query(':enter, :leave', style({ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }), { optional: true }),
        query(':leave', style({ transform: "translate3d(0,0,0)" })),
        query(':enter', style({ transform: "translate3d(-50%,0,0)"})),
        sequence([
            query(':leave', animateChild()), 
            group([
                query(':leave', [
                    animate('1s '+cubicBezier, 
                      style({ transform: "translate3d(100%,0,0)" }))
                ]),
                query(':enter', [
                  animate('1s '+cubicBezier, 
                    style({ transform: "translate3d(0,0,0)" }))
                ])
            ]),
            query(':enter', animateChild()),
        ])
    ];

const animIntroToStory = [
        query(':enter, :leave', style({ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }), { optional: true }),
        query(':leave', style({ transform: "translate3d(0,0,0) scale(1,1)" })),
        query(':enter', style({ transform: "translate3d(20%,13%,0) scale(.4,.4)", opacity: 0 })),
        sequence([
            query(':leave', animateChild()), 
            group([
                query(':leave', [
                    animate('.7s '+cubicBezier, 
                      style({ transform: "translate3d(-10%,-20%,0) scale(.4,.4)" })),
                    animate('.7s ease-in', 
                      style({ transform: "translate3d(-11%,-20%,0) scale(.4,.4)" })),
                    animate('.5s ease-in', 
                      style({ transform: "translate3d(-15%,-20%,0) scale(.4,.4)", opacity: 0 }))
                ]),
                query(':enter', [
                  animate('1.5s 2s ease-out', 
                    style({ transform: "translate3d(15%,13%,0) scale(.4,.4)", opacity: 1 })),
                  animate('.7s '+cubicBezier, 
                    style({ transform: "translate3d(0,0,0) scale(1,1)", opacity: 1 }))
                ])
            ]),
            query(':enter', animateChild()),
        ])
    ]


export const animRoutes =
trigger('animRoutes', [

    

    //Go into story
    transition(matchesIntroToStory, animIntroToStory),


    //Go Top
    transition(matchesPrevSection, animPrevSection),

    //Go Bottom
    transition(matchesNextSection, animNextSection),
    
    transition(matchesGoHome, animBack)

   
]);




export const openClose = 
trigger('openClose', [
  transition( ':enter', [
    query('.timeline-section__name > .name', style({ opacity: 0, transform: "translate3d(0,-10px,0)" })),
    query('.timeline-section__events', style({ opacity: 0, transform: "translate3d(0,10px,0)" })),
    query('.timeline-line', style({ opacity: .5, transform: "scale(1,0)" })),
    query('.timeline-dot', style({ transform: "scale(0,0)" })),
    group([
      style({opacity: 0}),
      animate('500ms', style({opacity: 1})),
      query('.timeline-section__name > .name', [
        animate('1s 1s ease', style({
          opacity: 1,
          transform: "translate3d(0,0px,0)"
        }))
      ]),
      query('.timeline-section__events', [
        animate('1s 1s ease', style({
          opacity: 1,
          transform: "translate3d(0,0px,0)"
        }))
      ]),
      query('.timeline-line', [
        animate('1.5s 1s ease', style({
          opacity: 1,
          transform: "scale(1,1)"
        }))
      ]),
      query('.timeline-dot', 
        stagger(0, [
          animate('.2s 1.8s ease', style({
            transform: "scale(1,1)"
          }))
        ])
      )
    ])  
  ]),
  transition( ':leave', [
    /*query('.timeline-section__name > .name', style({ opacity: 0, transform: "translate3d(0,-10px,0)" })),
    query('.timeline-section__events', style({ opacity: 0, transform: "translate3d(0,10px,0)" })),
    query('.timeline-line', style({ opacity: .5, transform: "scale(1,0)" })),
    query('.timeline-dot', style({ transform: "scale(0,0)" })),*/
    group([
      animate('500ms 1s', style({opacity: 0})),
      query('.timeline-section__name > .name', [
        animate('1s ease', style({
          opacity: 0,
          transform: "translate3d(0,10px,0)"
        }))
      ]),
      query('.timeline-section__events', [
        animate('1s ease', style({
          opacity: 0,
          transform: "translate3d(0,-10px,0)"
        }))
      ]),
      query('.timeline-line', [
        animate('1s ease', style({
          opacity: .5,
          transform: "scale(1,0)"
        }))
      ]),
      query('.timeline-dot', 
        animate('.2s ease', style({
          transform: "scale(0,0)"
        }))
      )
    ])  
  ])
  
]);
